import {
  FormContainerWithHeader,
  FormTextField,
} from '../../../../presentation';

import { getFieldProps } from '@converge/data';

interface IProps {
  isReadonly: boolean;
}

export const UnderwritingOverviewSubmissionNotesFormSection = ({
  isReadonly,
}: IProps) => {
  return (
    <FormContainerWithHeader title={'Submission Notes'}>
      <FormTextField
        {...getFieldProps('notes', isReadonly, '')}
        containerWidth={12}
        isRichText
        showToolbarEvenIfNotEditable={true}
      />
    </FormContainerWithHeader>
  );
};
